
import {snapshot} from "valtio";
import store from "@/store";

const previewTheme = (id: string) => {
    const {currentUser} = snapshot(store);
    const companyName = currentUser?.selectedCompany?.store_name
    const PLUGIN_API_URL = import.meta.env.VITE_3D_PLUGIN_V2
    const sku = '51000';
    const url = `${PLUGIN_API_URL}/?sku=${sku}&store_name=${companyName}&theme=${id}&disable_legal_compliance=true&disable_profanity_check=true&disable_create_new_product=true&disable_add_to_card=true&development=true`;
    window.open(url, '_blank');
}

export default previewTheme;